<div class="session-extend-modal">
  <h2 class="modal-title">Need more time?</h2>
  <p class="modal-message">
    You will be automatically signed out in {{ timeRemainingFormatted }}, or you may extend your
    session.
  </p>
  <div class="modal-actions">
    <button class="btn-secondary" (click)="onSignOut()">Sign out</button>
    <button class="btn-primary" (click)="onExtendSession()">Extend my session</button>
  </div>
</div>
